import React, { useMemo, useState } from 'react';
import { Modal, Button, Message } from 'semantic-ui-react';
import styles from './ErrorModal.module.scss';

const ErrorModal = ({ open, error, agency, onClear, children, title }) => {
	const emails = useMemo(() => {
		let _emails = agency.emails || [];
		return _emails;
	}, [agency]);

	const phones = useMemo(() => {
		let _phones = (agency.producer || agency).phones || [];
		if (_phones.length === 0) {
			_phones = agency.phones || [];
		}
		return _phones;
	}, [agency]);

	const [showError, setShowError] = useState(false);

	return (
		<Modal open={open} size='tiny'>
			<Modal.Header onClick={() => setShowError(true)}>{title || "Error"}</Modal.Header>
			<Modal.Content>
				{error && showError && (
					<Message error icon='warning'>
						{error}
					</Message>
				)}
				{children}
				<div className={styles.center}>
					<div>
						<b>Agency Information</b>
					</div>
					<div>{agency.displayName}</div>
					{agency.producer && <div>{agency.producer.displayName}</div>}
					<div>{agency.addressLine1}</div>
					<div>{agency.addressLine2}</div>
					<div>{phones[0]}</div>
					<div><a href={`mailto:${emails[0]}`} target="_blank" rel="noopener noreferrer">{emails[0]}</a></div>
				</div>
			</Modal.Content>
			<Modal.Actions>
				<Button id="closeBtn" primary onClick={onClear}>
					Close
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ErrorModal;